module.exports = __webpack_public_path__ + "static/media/JESSICA MUSTAFA .8ba8a7fc.png";